import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    IGeneralSettings,
    ISettingsReducer,
    IBackupSettings,
} from '../../types/settings'
import { fetchProductGeneralSettings } from '../async-thunks/settings/fetchProductGeneralSettings'
import { fetchProductBackupSettings } from '../async-thunks/settings/fetchProductBackupSettings'

const initialState: ISettingsReducer = {
    isLoading: false,
    error: '',
    isBackupLoading: false,
    backupError: '',

    productsSettings: {},
}

const settingsSlice = createSlice({
    name: 'settingsSlice',
    initialState,
    reducers: {
        modifyGeneralSettings: (
            state,
            action: PayloadAction<{
                guid: string
                data: IGeneralSettings
            }>
        ) => {
            const { guid, data } = action.payload

            if (!state.productsSettings[guid]) {
                // @ts-expect-error
                state.productsSettings[guid] = {}
            }
            state.productsSettings[guid].generalSettings = data
        },
        resetGeneralSettings: (state, action: PayloadAction<string>) => {
            const guid = action.payload
            state.productsSettings[guid].generalSettings =
                state.productsSettings[guid].generalSettingsDefault
        },
        modifyBackupSettings: (
            state,
            action: PayloadAction<{
                guid: string
                data: IBackupSettings
            }>
        ) => {
            const { guid, data } = action.payload

            if (!state.productsSettings[guid]) {
                // @ts-expect-error
                state.productsSettings[guid] = {}
            }
            state.productsSettings[guid].backupSettings = data
        },
        resetBackupSettings: (state, action: PayloadAction<string>) => {
            const guid = action.payload
            state.productsSettings[guid].backupSettings =
                state.productsSettings[guid].backupSettingsDefault
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductGeneralSettings.pending, (state) => {
                state.isLoading = true
                state.error = ''
            })
            .addCase(
                fetchProductGeneralSettings.fulfilled,
                (
                    state,
                    action: PayloadAction<{
                        guid: string
                        data: any
                    }>
                ) => {
                    const { guid, data } = action.payload

                    state.isLoading = false
                    state.error = ''
                    if (!state.productsSettings[guid]) {
                        // @ts-expect-error
                        state.productsSettings[guid] = {}
                    }
                    state.productsSettings[guid].generalSettingsDefault = data
                    state.productsSettings[guid].generalSettings = data
                }
            )
            .addCase(fetchProductGeneralSettings.rejected, (state) => {
                state.isLoading = false
                state.error = 'errors.messages.onGeneralSettingsFetch'
            })
            .addCase(fetchProductBackupSettings.pending, (state) => {
                state.isBackupLoading = true
                state.backupError = ''
            })
            .addCase(
                fetchProductBackupSettings.fulfilled,
                (
                    state,
                    action: PayloadAction<{
                        guid: string
                        data: IBackupSettings
                    }>
                ) => {
                    const { guid, data } = action.payload

                    state.isBackupLoading = false
                    state.backupError = ''
                    if (!state.productsSettings[guid]) {
                        // @ts-expect-error
                        state.productsSettings[guid] = {}
                    }
                    state.productsSettings[guid].backupSettingsDefault = data
                    state.productsSettings[guid].backupSettings = data
                }
            )
            .addCase(fetchProductBackupSettings.rejected, (state) => {
                state.isBackupLoading = false
                state.backupError = 'errors.messages.onDbBackupSettingsFetch'
            })
    },
})

export const { actions: settingsActions } = settingsSlice
export const { reducer: settingsReducer } = settingsSlice
